import { useState } from "react";
import { validateInput } from "../utils/utils";
import { login, recoveryPass, saveNewPassword, signup } from "../services/auth";
import useChatbotConfig from "./useChatbotConfig";
import { useNavigate, useParams } from "react-router-dom";
import { completeRegister } from "../services/admin";
import {
  validateLoginSchema,
  validateRegisterSchema,
} from "../schemas/authSchemas";

export default function useAuth() {
  const navigate = useNavigate();
  const { token, id } = useParams();
  const { saveToken } = useChatbotConfig();

  const [page, setPage] = useState(1);
  const [dataLogin, setDataLogin] = useState({ username: "", password: "" });
  const [errorMsg, setErrorMsg] = useState("");
  const [dataRegister, setDataRegister] = useState({
    name: "",
    email: "",
    username: "",
    password: "",
    password2: "",
  });
  const [tab, setTab] = useState(1);
  const [emailToRecovery, setEmailToRecovery] = useState("");
  const [newPasswords, setNewPasswords] = useState({
    password: "",
    password2: "",
  });

  const handleSubmitLogin = async (e) => {
    e.preventDefault();
    setErrorMsg("");
    if (validateLoginSchema(dataLogin).success) {
      const res = await login(dataLogin);
      if (res[0]?.jwt) {
        saveToken(res[0].jwt);
        setDataLogin({ username: "", password: "" });
      } else {
        let msg =
          "No fue posible conectarse al servidor, inténtalo nuevamente más tarde.";
        if (res[1] && res[1].data?.message) {
          msg = res[1].data.message;
        }
        setErrorMsg(msg);
      }
    } else {
      setErrorMsg("Debes completar todos los campos obligatorios.");
    }
  };

  const handleSubmitRegister = async (e) => {
    e.preventDefault();
    setErrorMsg("");
    const validation = validateRegisterSchema(dataRegister);
    if (!validation.success) {
      setErrorMsg(validation.error.issues.map((issues) => issues.message));
    } else {
      const res = await signup(dataRegister);
      if (res[0]) {
        setPage(1);
        setDataRegister({
          name: "",
          email: "",
          username: "",
          password: "",
          password2: "",
        });
      } else {
        let msg =
          "No fue posible conectarse al servidor, inténtalo nuevamente más tarde.";
        if (res[1] && res[1].data?.message) {
          msg = res[1].data.message;
        }
        setErrorMsg(msg);
      }
    }
  };
  const handleChangeLogin = (e) => {
    const value = e.target.value;
    let type = e.target.type;

    if (e.target.name === "username") {
      type = "username";
    }
    if (validateInput(type, value)) {
      setDataLogin({
        ...dataLogin,
        [e.target.name]: value,
      });
    }
  };
  const handleChangeRegister = (e) => {
    const value = e.target.value;
    let type = e.target.type;
    if (e.target.name === "username") {
      type = "username";
    }
    if (validateInput(type, value)) {
      setDataRegister({
        ...dataRegister,
        [e.target.name]: value,
      });
    }
  };

  const changeLoginPage = (nextPage) => {
    setPage(nextPage);
    setErrorMsg("");
  };

  const handleSubmitRecoveryPass = async (e) => {
    e.preventDefault();
    setErrorMsg("");
    if (emailToRecovery !== "") {
      const res = await recoveryPass(emailToRecovery);
      if (res[0]) {
        setEmailToRecovery("");
        setTab(2);
      } else {
        let msg =
          "No fue posible conectarse al servidor, inténtalo nuevamente más tarde.";
        if (res[1] && res[1].data && res[1].data.message) {
          msg = res[1].data.message;
        }
        setErrorMsg(msg);
      }
    }
  };
  const handleChangeRecoveryPass = (e) => {
    if (validateInput("email", e.target.value)) {
      setEmailToRecovery(e.target.value);
    }
  };

  const handleSubmitResetPassword = async (e) => {
    e.preventDefault();
    setErrorMsg("");
    if (
      newPasswords.password.trim() !== "" &&
      newPasswords.password2.trim() !== "" &&
      newPasswords.password === newPasswords.password2
    ) {
      const res = await saveNewPassword(token, newPasswords.password);
      if (res[0]) {
        setNewPasswords({ password: "", password2: "" });
        navigate("/login");
      } else {
        let msg =
          "No fue posible conectarse al servidor, inténtalo nuevamente más tarde.";
        if (res[1] && res[1] && res[1].message) {
          msg = res[1].message;
        }
        setErrorMsg(msg);
      }
    } else {
      if (
        newPasswords.password.trim() === "" ||
        newPasswords.password2.trim() === ""
      ) {
        setErrorMsg("Complete todos los campos");
        return;
      }
      setErrorMsg("Las contraseñas no coinciden");
    }
  };

  const handleChangeNewPasswords = (e) => {
    if (validateInput(e.target.type, e.target.value)) {
      setNewPasswords({ ...newPasswords, [e.target.name]: e.target.value });
    }
  };

  const handleSubmitRegisterInvitedUser = async (e) => {
    e.preventDefault();
    setErrorMsg("");
    try {
      if (
        dataRegister.name.trim() === "" ||
        dataRegister.username.trim() === "" ||
        dataRegister.password.trim() === "" ||
        dataRegister.password2.trim() === ""
      ) {
        setErrorMsg("Debes completar todos los campos obligatorios.");
      } else {
        if (dataRegister.password !== dataRegister.password2) {
          setErrorMsg("Las contraseñas ingresadas deben coincidir.");
        } else {
          const res = await completeRegister(id, dataRegister);
          if (res) {
            setDataRegister({
              name: "",
              email: "",
              username: "",
              password: "",
              password2: "",
            });
            navigate("/login");
          }
        }
      }
    } catch (err) {
      if (err?.response) {
        setErrorMsg(err.response.message);
      } else {
        setErrorMsg(
          "No fue posible conectarse al servidor, inténtalo nuevamente más tarde."
        );
      }
    }
  };

  return {
    page,
    dataLogin,
    dataRegister,
    errorMsg,
    tab,
    emailToRecovery,
    newPasswords,
    changeLoginPage,
    handleSubmitLogin,
    handleChangeLogin,
    handleSubmitRegister,
    handleChangeRegister,
    handleSubmitRecoveryPass,
    handleChangeRecoveryPass,
    handleSubmitResetPassword,
    handleChangeNewPasswords,
    handleSubmitRegisterInvitedUser,
  };
}
